import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { LaboratoryHttpHeaderService } from 'app/core/services/prothesis-api/laboratory-http-header.service';
import { CustomDatePipe } from 'app/shared/pipes/custom-date.pipe';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SubscriptionBannerModel } from './subscription-banner.model';
import { SubscriptionBannerModelHelper } from './subscription-banner.model.helper';
import { MatCardContent } from '@angular/material/card';
import { NgClass } from '@angular/common';
import { CustomDatePipe as CustomDatePipe_1 } from '../../../shared/pipes/custom-date.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CustomDatePipe],
  selector: 'app-subscription-banner',
  styleUrls: ['./subscription-banner.component.scss'],
  templateUrl: './subscription-banner.component.html',
  imports: [MatCardContent, NgClass, CustomDatePipe_1],
})
export class SubscriptionBannerComponent implements OnInit {
  public subscriptionBanner: SubscriptionBannerModel;

  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _laboratoryHttpHeaderService = inject(LaboratoryHttpHeaderService);
  private _unsubscribeAll: Subject<void>;

  public constructor() {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  public ngOnInit(): void {
    this._laboratoryHttpHeaderService.onHttpHeaderChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      const httpHeader = this._laboratoryHttpHeaderService.getHttpHeader();
      this.subscriptionBanner = SubscriptionBannerModelHelper.fromHttpHeader(httpHeader);

      // Mark for check
      this._changeDetectorRef.markForCheck();
    });
  }
}
